import { message } from "antd";
import { history } from '@umijs/max';

/**
 * 设置token
 */
export const setToken = (token: string) => {
    if (!token) return message.error('token 不存在');
    window.localStorage.setItem('nanyue_manage_access_token', token);
    return true;
};

/**
 * 获取token
 */
export const getToken = () => {
    let token = window.localStorage.getItem('nanyue_manage_access_token');
    if (token) return token || '';
};

/**
 * 清除所有信息
 */
export const clear = () => {
    window.localStorage.clear();
};

/**
 * 退出登录
 */
export const logout = () => {
    clear()
    history.replace('/Login');
}